import React from 'react'
import DotsLoader from 'shared/components/loaders/dots'
import styled from 'styled-components'
import CreationToolStatus from '../../../../types/status'
import { OverlayBlock } from '../../../blocks'
import { TitleSmall } from '../../../typography'

const Loader = styled(OverlayBlock)`
    align-items: center;
    background: rgba(0, 0, 0, 0.7);
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 20px;
    text-align: center;
`

const Title = styled(TitleSmall)`
    padding-top: 20px;
`

type Props = {
    status: CreationToolStatus
}

const CreationUploadItemLoader = ({ status }: Props) => {
    const title = CreationToolStatus.title(status)

    return (
        <Loader>
            <DotsLoader />
            <Title>{title}</Title>
        </Loader>
    )
}

export default CreationUploadItemLoader
